import type { BuildingEntityBase } from "building-types/entities/buildingEntityBase";
import type { BuildingEntityHandleBase } from "building-types/entities/buildingEntityHandle";
import type { BuildingEntityType } from "building-types/entities/buildingEntityTypeTypes";
import type { DocEntityHandle } from "building-types/handles/docEntityHandleTypes";

export abstract class BuildingEntityNodeBase<E extends BuildingEntityBase<BuildingEntityType>> {
  constructor(protected readonly entity: E) {}

  get entityType(): E["entityType"] {
    return this.entity.entityType;
  }

  get handle(): BuildingEntityHandleBase<E["entityType"]> {
    return {
      entityType: this.entity.entityType,
      id: this.entity.id,
    };
  }

  get docEntityHandle(): DocEntityHandle | undefined {
    return this.entity.docEntityHandle;
  }

  get id(): string {
    return this.entity.id;
  }
}
